<template>
    <div v-show="materialRows.length">
        <div class="form">
            <div class="form-body form-horizontal">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="col-md-4 control-label">{{
                                    'purchase_order.material.table.planned_date' | trans
                                }}:</label>
                            <div class="col-md-8">
                                <date-picker
                                        v-model="formPlannedDate"
                                        :withlabel="false"
                                        :disabled="disabled"
                                        :time="false"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 pl-0">
                        <button
                                class="btn btn-primary"
                                :disabled="disabled"
                                @click="setPlannedDates">
                            {{ 'purchase_order.material.set_planned_dates_button' | trans }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <view-loader :loading="disabled" size="100px" show-content>
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover">
                            <thead>
                            <tr>
                                <th style="min-width: 250px">{{ 'purchase_order.material.table.material' | trans }}</th>
                                <th>{{ 'purchase_order.material.table.needed_amount' | trans }}</th>
                                <th v-if="isDev">{{ 'purchase_order.material.table.comment' | trans }}</th>
                                <th style="min-width: 450px;">{{
                                        'purchase_order.material.table.price_per_kg' | trans
                                    }}
                                </th>
                                <th>{{ 'purchase_order.material.table.to_order' | trans }}</th>
                                <th>{{ 'purchase_order.material.table.unit' | trans }}</th>
                                <th>{{ 'purchase_order.material.table.weight' | trans }}</th>
                                <th>{{ 'purchase_order.material.table.order_weight' | trans }}</th>
                                <th>{{ 'purchase_order.material.table.over_order' | trans }}</th>
                                <th>{{ 'purchase_order.material.table.price_per_unit' | trans }}</th>
                                <th style="min-width: 100px;">{{ 'purchase_order.material.table.amount' | trans }}</th>
                                <th style="min-width: 180px;">{{
                                        'purchase_order.material.table.planned_date' | trans
                                    }}
                                </th>
                                <th>{{ 'purchase_order.material.table.price_date' | trans }}</th>
                                <th>{{ 'purchase_order.material.table.product_name' | trans }}</th>
                                <th>{{ 'purchase_order.material.table.product_code' | trans }}</th>
                                <th>{{ 'purchase_order.material.table.supplier' | trans }}</th>
                                <th>{{ 'purchase_order.material.table.producer' | trans }}</th>
                                <th>{{ 'purchase_order.material.table.actions' | trans }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(materialRow, index) in materialRows" :key="index">
                                <td v-if="materialRow.type === 'defined'">{{ materialRow.materialName }}</td>
                                <td v-else>
                                    <single-select
                                            v-model="materialRow.materialId"
                                            :options="orderableMaterials"
                                            :disabled="disabled"
                                            open-direction="top"
                                            @dispatch="getOffersForMaterials(index, $event)"
                                    />
                                </td>
                                <td class="text-right">{{ materialRow.quantity | number(2) }}</td>
                                <td v-if="isDev" v-html="materialRow.comment"></td>
                                <td>
                                    <single-select
                                            v-model="materialRow.offer"
                                            :options="materialRow.offerOptions"
                                            :disabled="disabled"
                                            track-by="offerId"
                                            label="optionName"
                                            sort-by="kgPrice"
                                            :checked="materialRow.selectedOffer"
                                            :allow-empty="false"
                                            open-direction="top"
                                            @dispatch="changeOffer(index, $event)"
                                    />
                                </td>
                                <td>
                                    <input
                                            v-model="materialRow.toOrder"
                                            type="number"
                                            value="0"
                                            class="form-control"
                                            step="1"
                                            min="0"
                                            :disabled="materialRow.supplyWarehouseId !== null || disabled"
                                    >
                                </td>
                                <td>{{
                                        (materialRow.offer ? getOfferData(index, 'unit') : '') | unit
                                    }}
                                </td>
                                <td class="text-right">
                                    {{ getOfferData(index, 'weight') | number(2) }}
                                </td>
                                <td class="text-right">
                                    {{
                                        (materialRow.toOrder * getOfferData(index, 'weight')) | number(2)
                                    }}
                                </td>
                                <td class="text-right">
                                    {{
                                        (materialRow.toOrder * getOfferData(index, 'weight') - materialRow.quantity) | number(2)
                                    }}
                                </td>
                                <td class="text-right">
                                    {{ getOfferData(index, 'unitPrice') | number(2) }}
                                </td>
                                <td class="text-right">
                                    {{
                                        (getOfferData(index, 'unitPrice') * materialRow.toOrder) | number(2)
                                    }}
                                </td>
                                <td>
                                    <date-picker
                                            v-model="materialRow.plannedDate"
                                            :disabled="disabled"
                                            :withlabel="false"
                                            :time="false"
                                    />
                                </td>
                                <td class="text-nowrap">{{ getOfferData(index, 'dateString') }}</td>
                                <td class="text-nowrap">{{ getOfferData(index, 'productName') }}</td>
                                <td class="text-nowrap">{{ getOfferData(index, 'offerProductCode') }}</td>
                                <td class="text-nowrap">{{ getOfferData(index, 'supplierName') }}</td>
                                <td class="text-nowrap">{{ getOfferData(index, 'producer') }}</td>
                                <td>
                                    <button
                                            type="button"
                                            class="btn btn-danger"
                                            :disabled="disabled"
                                            :title="'grid.remove' | trans"
                                            @click="deleteRow(index)">
                                        <span class="fa fa-trash"></span>
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </view-loader>
                <div class="mt-10">
                    <button
                            class="btn"
                            :class="isForecast ? 'btn-warning' : 'btn-success'"
                            :disabled="disabled"
                            @click="generatePurchaseOrders">
                        {{ `purchase_order.material.generate${isForecast ? '_forecasts' : ''}` | trans }}
                    </button>
                    <button
                            class="btn btn-primary"
                            :disabled="disabled"
                            @click="addNew">
                        {{ 'purchase_order_item.add_new' | trans }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DateHelper from '@js/helpers/dateHelper'
import DatePicker from '@component/datePicker.vue'
import SingleSelect from '@component/singleselect.vue'
import ViewLoader from '@component/ViewLoader.vue'
import axios from 'axios'

export default {
  name: 'PurchaseOrderMaterials',
  components: {
    SingleSelect,
    DatePicker,
    ViewLoader
  },
  props: {
    disabled: {
      type: Boolean,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    isDev: {
      type: Boolean,
      required: true,
    },
    isForecast: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    let tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 1)
    return {
      formPlannedDate: DateHelper.format(tomorrow),
      orderableMaterials: [],
      materialRows: [],
      materialOffers: {},
    }
  },
  computed: {
    purchaseOrderItems() {
      return this.items.reduce((acc, item) => {
        const row = this.materialRows.find(materialRow => item.materialId === materialRow.materialId)

        if (row && row.offer) {
          const orderItem = {}
          Object.assign(orderItem, item)
          orderItem.offer = row.offer
          orderItem.plannedDate = row.plannedDate
          acc.push(orderItem)
        }

        return acc
      }, [])
    }
  },
  watch: {
    items: {
      handler(value) {
        this.createMaterialRows(value)
      },
      immediate: true,
    }
  },
  mounted() {
    this.getOrderableMaterials()
  },
  methods: {
    createMaterialRows(materials) {
      this.materialRows = materials.reduce((acc, material) => {
        const row = acc.find(materialRow => materialRow.materialId === material.materialId)
        if (row) {
          row.toOrder += material.toOrder
          row.quantity += material.quantity
        } else {
          const newRow = Object.assign({}, material)

          if (newRow.offer === null && Object.keys(material.offers).length > 0) {
            newRow.offerOptions = Object.values(newRow.offers)
            newRow.offerOptions.sort((a, b) => a.kgPrice - b.kgPrice)
          }

          newRow.plannedDate = this.formPlannedDate
          acc.push(newRow)
        }

        return acc
      }, [])
    },
    getOrderableMaterials() {
      const url = Routing.generate('api_get_materials_orderable', { context: 'dropdown' })
      this.$emit('request')

      axios.get(url).then(response => {
        this.orderableMaterials = response.data
      }, response => {
        this.handleAjaxError(response)
      }).finally(() => {
        this.$emit('response')
      })
    },
    updateRowOffer(id, offers) {
      this.materialOffers[id] = offers
      this.getItemsForMaterial(id).forEach(item => {
        item.offers = offers
        item.offerOptions = Object.values(offers)
        item.offerOptions.sort((a, b) => a.kgPrice - b.kgPrice)
        item.selectedOffer = item.offerOptions.length ? item.offerOptions[0].offerId : null
        item.offer = item.selectedOffer
      })
    },
    getOffersForMaterials(index, data) {
      const id = data.id
      if (this.materialOffers[id]) {
        this.updateRowOffer(id, this.materialOffers[id])
      } else {
        const url = Routing.generate('api_get_purchase_order_material_offers', { id })
        this.$emit('disable', true)

        axios.get(url).then(response => {
          this.updateRowOffer(id, response.data)
        }, response => {
          this.handleAjaxError(response)
        }).finally(() => {
          this.$emit('disable')
        })
      }
    },
    getItemsForMaterial(materialId) {
      return this.materialRows.filter(item => item.materialId === materialId)
    },
    addNew() {
      this.materialRows.push({
        categoryId: null,
        offer: null,
        offers: {},
        offerOptions: [],
        plannedDate: this.formPlannedDate,
        materialId: null,
        quantity: 0,
        toOrder: 0,
        unit: null,
        type: 'new',
        supplyWarehouseId: null
      })
    },
    generatePurchaseOrders() {
      const url = Routing.generate('api_generate_purchase_order_material')

      this.$emit('disable', true)
      axios.post(url, {
        items: this.purchaseOrderItems,
        forecast: this.isForecast
      }).then(() => {
        if (this.isForecast) {
          window.toastr.success(Translator.trans('purchase_order.material.messages.forecasts_generated'))
        } else {
          window.toastr.success(Translator.trans('purchase_order.material.messages.orders_generated'))
        }
        this.materialRows = []
      }, response => {
        this.handleAjaxError(response, false, Translator.trans('purchase_order.material.messages.generate_error'))
      }).finally(() => {
        this.$emit('disable')
      })
    },
    getOfferData(index, name) {
      const offerId = this.materialRows[index].offer
      return offerId ? this.materialRows[index].offers[offerId][name] : null
    },
    changeOffer(index, data) {
      this.getItemsForMaterial(this.materialRows[index].materialId).forEach(item => {
        item.toOrder = Math.ceil(item.quantity / data.weight)
        item.offer = data.offerId
      })
    },
    deleteRow(index) {
      if (confirm(Translator.trans('form.confirm'))) {
        this.materialRows.splice(index, 1)
      }
    },
    setPlannedDates() {
      this.materialRows.forEach(item => {
        item.plannedDate = this.formPlannedDate
      })
    },
  },
}
</script>

<style scoped>
.pl-0 {
    padding-left: 0;
}

.btn + .btn {
    margin-left: 5px;
}

.text-right {
    text-align: right
}

.mt-10 {
    margin-top: 10px;
}
</style>
